import React from "react";
import "../../assets/css/DefaultContent/DefaultContent.css";

function DefaultContent() {
  return (
  <div className="default-content">
              <h1 className="why-ssdn-heading-1">Why SSDN</h1>
              <p className="why-ssdn">
                Empowering your growth with industry-leading IT training, consulting,
                and innovative tech solutions—trusted by professionals, powered by experts.
              </p>

              <div className="info-cards">
                <div className="info-card">
                  <h3 className="why-ssdn-h-1">Our Vision</h3>
                  <p className="why-ssdn-heading"><b>Transforming Lives, One Mind at a Time Empowering Minds</b></p>
                  <p className="why-ssdn-heading">Our core value is to transform lives through knowledge and skill development.</p>

                  <h4 className="why-ssdn-heading">Boosting Productivity</h4>
                  <p className="why-ssdn-heading">We aim to enhance efficiency for over 100 organizations in the next 3 years.</p>

                  <h4 className="why-ssdn-heading">Tailored Digital Skills</h4>
                  <p className="why-ssdn-heading">We're committed to delivering customized digital training at your doorstep.</p>

                  <h4 className="why-ssdn-heading">Million Minds Initiative</h4>
                  <p className="why-ssdn-heading">By 2027, we pledge to empower 1 million minds with cutting-edge skills.</p>
                </div>

                <div className="info-card">
                  <h3 className="why-ssdn-h-1">Our Mission</h3>
                  <p className="why-ssdn-heading"><b>Our Mission emanates from:</b></p>
                  <p className="why-ssdn-heading">Vasudhaiva Kutumbakam - One Earth One World</p>

                  <h4 className="why-ssdn-heading">Continuous Learning</h4>
                  <p className="why-ssdn-heading">We foster a culture of growth, empowering individuals and organizations with cutting-edge skills.</p>

                  <h4 className="why-ssdn-heading">Tailored Solutions</h4>
                  <p className="why-ssdn-heading">Our knowledge and skills are customized to meet specific needs of clients and society.</p>

                  <h4 className="why-ssdn-heading">Sustainable Digital World</h4>
                  <p className="why-ssdn-heading">We strive to create a balanced, tech-driven ecosystem for all to thrive in.</p>
                </div>
              </div>
            </div>
  )
}

export default DefaultContent;